import { topLearners } from 'assets';
import { motion } from 'framer-motion';
import Image from 'next/image';
import React from 'react';

import Card from '@/components/Subscription/Reviews/card';

const ReviewsSection = () => {
  const reviews = [
    {
      name: 'Aarav S.',
      description:
        'Good mix of printed and digital books. Helped me learn consistently and with ease.',
    },
    {
      name: 'Meenal D.',
      description:
        'Monthly books kept me reading. Digital access made it easy to read anytime, anywhere.',
    },
    {
      name: 'Harsh D.',
      description:
        'I read more now and often refer to older books when I need help.',
    },
  ];
  const reviews2 = [
    {
      name: 'Arjun R.',
      description:
        'Easy to read anytime on my phone during travel, breaks, or even at work.',
    },
    {
      description:
        'Fits perfectly into my routine. I read more often, even with a busy schedule.',
      name: 'Rajeev M.',
    },
    {
      description:
        'Books are simple, high quality, and useful. Great value for a small price.',
      name: 'Ravi K.',
    },
  ];
  return (
    <div>
      <p className='md:text-[32px] text-lg font-semibold md:leading-10 text-white/60 md:mt-16 mt-8 mb-16 text-center'>
        People Love <span className='text-white'>ZebraLearn</span>
      </p>
      <div className='flex gap-10 items-center justify-center  lg:mb-16 mb-[-120px] md:mx-24 mx-2 z-0'>
        <div className=' lg:flex hidden flex-col gap-3'>
          {reviews.map((i, index) => (
            <Card
              className={index === 1 ? 'ms-6' : ''}
              name={i.name}
              description={i.description}
              key={index}
            />
          ))}
        </div>
        <Image
          className='xl:w-[295px] w-[200px] h-auto drop-shadow-[0_4px_100px_rgba(255,255,255,0.15)] '
          src={topLearners}
          alt='Person'
          width={295}
          height={600}
        />
        <div className='lg:flex hidden flex-col gap-3'>
          {reviews2.map((i, index) => (
            <Card
              className={index === 1 ? 'me-6' : ''}
              name={i.name}
              description={i.description}
              key={index}
            />
          ))}
        </div>
      </div>
      <div className='lg:hidden flex flex-col gap-1 z-20 relative shadow-[0px_-40px_40px_0px_rgb(0,0,0)] bg-black'>
        <div className='overflow-hidden z-20'>
          <motion.div
            className='flex gap-1'
            animate={{ x: ['0%', '-100%'] }}
            transition={{
              repeat: Infinity,
              repeatType: 'loop',
              duration: 20,
              ease: 'linear',
            }}
          >
            {[...Array(3)].flatMap(() =>
              reviews.map((i, index) => (
                <Card
                  name={i.name}
                  description={i.description}
                  className='min-w-72'
                  key={index}
                />
              )),
            )}
          </motion.div>
        </div>
        <div className='overflow-hidden'>
          <motion.div
            className='flex gap-1'
            animate={{ x: ['0%', '-100%'] }}
            transition={{
              repeat: Infinity,
              repeatType: 'loop',
              duration: 20,
              ease: 'linear',
            }}
          >
            {[...Array(3)].flatMap(() =>
              reviews2.map((i, index) => (
                <Card
                  name={i.name}
                  description={i.description}
                  className='min-w-72'
                  key={index}
                />
              )),
            )}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default ReviewsSection;
